import { AnalyzeConstants } from '../../../src/_constants/Analyze/analyze.constants';

const initialState = { paAnaTeamListLoading: true, data: '', error: false };

export function getPaAnanlyzeTeamListReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_PA_ANA_TEAM_LIST:
            return {
                paAnaTeamListLoading: true,
                data: '',
                error: false
            };
        case AnalyzeConstants.RECEIVE_PA_ANA_TEAM_LIST:
            return {
                paAnaTeamListLoading: false,
                data: action.res,
                error: false
            };
        case AnalyzeConstants.ERROR_PA_ANA_TEAM_LIST:
            return {
                paAnaTeamListLoading: false,
                data: '',
                error: action.error
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/getPaAnanlyzeTeamList.reducer.js